import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { UserProfileModel } from '../../models/repository/user-profile.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { UserService } from '../../services/user.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-review-profile-info',
  templateUrl: './review-profile-info.component.html',
  styleUrls: ['./review-profile-info.component.scss']
})
export class ReviewProfileInfoComponent extends BaseUnsubscribeComponent implements OnInit {
  public userProfileForm: FormGroup;
  public userProfleModel: UserProfileModel;
  @Input() public data: any;
  imageUrl: any = 'assets/images/user.png';
  constructor(private readonly formBuilder: FormBuilder,
    private readonly userService: UserService,
    private readonly httpErrorHandleService: HttpErrorHandlerService) {
      super();
  }

  disableAllFields() {
    Object.keys(this.userProfileForm.controls).forEach((key) => {
      this.userProfileForm.get(key).disable();
    });
  }

  ngOnInit(): void {

    this.loadProfile();
    this.userProfileForm = this.formBuilder.group({
      userName: [{ value: '', disabled: true }],
      password: [{ value: '', disabled: true }],
      confirmPassword: [{ value: '', disabled: true }],
      isPasswordChanged: [false],
      gender: ['dr'],
      firstName: [''],
      lastName: [''],
      title: [''],
      email: [''],
      degree: [''],
      accreditation: [''],
      trackingURL: [''],
      organisation: [''],
      organisationID: [''],
      dicomDeviceId: [0],
      licenseNumber: [''],
      suffix: [''],
      websiteUrl: [''],
      address: [''],
      stateName: [''],
      countryName: [''],
      postCode: [''],
      phoneNumber: [''],
      phoneNumber2: [''],
      city: [''],
      contactNumber1: [''],
      contactNumber2: [''],
    });
    this.disableAllFields();
  }

  private loadProfile() {
    this.userService
      .getReviewProfile(this.data?.memberId, this.data?.userId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          if (response) {
            this.userProfleModel = response;
            if (this.userProfleModel.image) {
              this.imageUrl = this.userProfleModel.image;
            }
            const formData = {
              userName: this.userProfleModel?.userName,
              firstName: this.userProfleModel?.firstName,
              lastName: this.userProfleModel?.lastName,
              title: this.userProfleModel?.title,
              email: this.userProfleModel?.email,
              degree: this.userProfleModel?.degree,
              accreditation: this.userProfleModel?.accreditation,
              trackingURL: this.userProfleModel?.trackingURL,
              organisation: this.userProfleModel?.organisation,
              organisationID: this.userProfleModel?.organisationID,
              dicomDeviceId: this.userProfleModel?.dicomDeviceId,
              licenseNumber: this.userProfleModel?.licenseNumber,
              suffix: this.userProfleModel?.suffix,
              websiteUrl: this.userProfleModel?.websiteUrl,
              address: this.userProfleModel?.address,
              stateName: this.userProfleModel?.stateName,
              countryName: this.userProfleModel?.countryName,
              postCode: this.userProfleModel?.postCode,
              phoneNumber: (this.userProfleModel?.phoneNumberCountryCode ?? '') + (this.userProfleModel?.phoneNumber ?? ''),
              phoneNumber2: (this.userProfleModel?.phoneNumber2CountryCode ?? '') + (this.userProfleModel?.phoneNumber2 ?? ''),

              suburb: this.userProfleModel?.suburb,
              city: this.userProfleModel?.city,
              contactNumber1: (this.userProfleModel?.contactNumber1CountryCode ?? '') + (this.userProfleModel?.contactNumber1 ?? ''),
              contactNumber2: (this.userProfleModel?.contactNumber2CountryCode ?? '') + (this.userProfleModel?.contactNumber2 ?? ''),
              file: '',
              imageUrl: this.userProfleModel?.image,
            };

            this.userProfileForm.patchValue(formData);
          }
        },
        (error) => {
          if (error) {
            this.httpErrorHandleService.ShowErrorMessage(error);
          }
        }
      );
  }

}
